import base from 'components/base'
import componentInit from 'components/componentInit'
import $ from 'jquery'

class shareButtons extends base
{
  elements = {
    container: null,
    toggleButton: null,
    buttons: [],
    siteHeaderCenter: null
  }

  constructor(parentElement)
  {
    super()

    $(document).ready(() =>
    {
      this.elements.container = $(parentElement).find('#share-buttons').get(0)
      this.elements.toggleButton = $(this.elements.container).children('button').get(0)
      this.elements.buttons = $(this.elements.container).find('a').get()
      this.elements.siteHeaderCenter = $(this.elements.container).parent().get(0)

      this.bindEvents()
    })
  }

  bindEvents()
  {
    $(this.elements.toggleButton).on('click.'+ module.id, () =>
    {
      this.toggle(this.elements.container)
    })

    if(typeof gtag === 'function')
    {
      $(this.elements.buttons).on('click.'+ module.id, (event) =>
      {
        let method = $(event.currentTarget).attr('class').match(/^button\s+([^\s]+)/)
        if(method && method[1])
          gtag('event', 'share', {
            method: method[1],
            content_type: 'page',
            content_id: window.location.pathname
          })
      })
    }
  }

  open(element)
  {
    $(this.elements.siteHeaderCenter).toggleClass('share-buttons-open', true)
    super.open(element)
  }

  close(element)
  {
    $(this.elements.siteHeaderCenter).toggleClass('share-buttons-open', false)
    super.close(element)
  }
}

componentInit.prototype.callbacks[module.id] = function(parentElement)
{
  new shareButtons(parentElement)
}

export default shareButtons



// WEBPACK FOOTER //
// ./vendor/response200/kustantajat/applications/publicFrontend/scripts/components/shareButtons.js